import { Component, OnInit } from '@angular/core';
import { ContractDto } from 'src/app/models/contractDto';
import { ContractsService } from 'src/app/services/contracts.service';

@Component({
  selector: 'app-expressapprovals',
  templateUrl: './expressapprovals.component.html',
  styleUrls: ['./expressapprovals.component.css']
})
export class ExpressApprovalsComponent implements OnInit {
  Requests: ContractDto[] = [];
  constructor(private contractsService: ContractsService) { }

  ngOnInit(): void {
    this.loadpendingApproval();
  }

async loadpendingApproval()
{

  let resContracts = await this.contractsService.getPendingExpressApproval().toPromise();
  this.Requests = <ContractDto[]>resContracts.responseData;
}

}
